import Axios from 'axios';
import { baseUrl } from '../config/serviceConfig';

const PutFormData = (path, data, token) => {
    return Axios({
        method: 'PUT',
        url: baseUrl + path,
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': token
        }
    })
}

export default PutFormData;